import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

// The assistant reply is generated synchronously server-side (5-30s),
// so the default 15s axios timeout is not enough for this endpoint.
const AI_RESPONSE_TIMEOUT_MS = 60_000;

class ClaimChatService {
  index(declarationId) {
    return securedAxiosInstance.get(`/claims_declaration/${declarationId}/chat_messages`);
  }

  create(declarationId, content) {
    return securedAxiosInstance.post(`/claims_declaration/${declarationId}/chat_messages`, toSnakeCase({ content }), {
      timeout: AI_RESPONSE_TIMEOUT_MS,
    });
  }
}

export default new ClaimChatService();
